import { orderStatusesColorSchema } from 'pages/Monitoring/OrderConversionChart/constants/orderStatusesColorSchema';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { OrderConversionChartStatuses } from 'types/embedded/orderConversion';

type Props = {
  title: string;
  status: OrderConversionChartStatuses;
};

export const OrderConversionChartProvidersRatioHint: React.FC<Props> = ({ title, status }) => {
  return (
    <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
      <Box
        sx={{
          width: '16px',
          height: '16px',
          backgroundColor: orderStatusesColorSchema[status],
        }}
      ></Box>
      <Typography fontSize="12px">{title}</Typography>
    </Box>
  );
};
